<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <router-link :to="editRoute">
      <feather-icon
        icon="pen"
        svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      />
    </router-link>
    <feather-icon
      icon="trash"
      svg-classes="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "CellRendererActions",
  computed: {
    editRoute() {
      return `/project/${this.params.data.id}/edit`;
    }
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Sie sind dabei "${this.params.data.title}" zu löschen`,
        accept: this.deleteRecord,
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              vacancyProjectDelete(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.params.data.id
          }
          // update: (store, { data: { vacancyDelete } }) => {
          // console.log(store);
          // console.log(data);
          // }
        })
        .then(() => {
          this.showDeleteSuccess();
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "Das ausgewählte Stellenangebot wurde gelöscht"
      });
    }
  }
};
</script>
